import { atom } from 'recoil';

export const searchValueAtom = atom({
  key: 'searchValueAtom',
  default: '',
}) 